import * as React from 'react';
import { Card, Button, InputGroup, Accordion, Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './SettingsDeal.scss';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import PageTable from '../../../Shared/PageTable/PageTable';
import Field from '../../../Shared/Wizard/Field/Field';


function SettingsDeal(props) {
    const t = useTranslate();  
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [allResources, setAllResources] = useState<Array<Object>>([]);
    const [allResourceTypes, setAllResourceTypes] = useState<Array<Object>>([]);
    const [allDeals, setAllDeals] = useState<Array<Object>>([]);

    const [editDeal, setEditDeal] = useState<Object>({});
    const [deleteDeal, setDeleteDeal] = useState("");

    const [showNewModal, setShowNewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showChangeDefaultModal, setShowChangeDefaultModal] = useState(false);

    const [isDefaultDeal, setIsDefaultDeal] = useState(false);
    const [nonDefaultDeal, setNonDefaultDeal] = useState(false);

    const [newDealName, setNewDealName] = useState("");
    const [newDealDescription, setNewDealDescription] = useState("");
    const [newPriceList, setNewPriceList] = useState<Array<Object>>([]);
    const [newDefaultDeal, setNewDefaultDeal] = useState(false);

    const setEditDealName = value => { setEditDeal(editDeal => ({...editDeal, name: value}));}
    const setEditDealDescription = value => { setEditDeal(editDeal => ({...editDeal, description: value}));}
    const setEditDefaultDeal = value => { setEditDeal(editDeal => ({...editDeal, isDefaultDeal: value}));}

    const [updateTable, setUpdateTable] = useState(0);

    const handleCloseNewModal = () => {
        setShowNewModal(false);
        setIsDefaultDeal(false);
        resetForm();
    };

    const handleShowNewModal = () => {
        setShowNewModal(true);
        setIsDefaultDeal(false);
        resetForm();
    };

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDeleteDeal(dataLine);
        setShowDeleteModal(true);
    };

    const handleOpenDeal = (dataLine)=> {
        setEditDeal(dataLine);
        setShowEditModal(true);
    }
    const resetForm = () => {
        setNewDealName("");
        setNewDealDescription("");
        setNewDefaultDeal(false);
        setNewPriceList([]);
        setEditDeal([]);
    }

    const addPriceList = () => {
        setNewPriceList([...newPriceList != undefined ? newPriceList : [], {resource: "", resourceType: "", resourceSubType: "", unit:"", price:""}]);
    }

    const deletePriceList = (key) => {
        let temp = newPriceList;
        temp.splice(key, 1);
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeNewResourceType= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["resourceType"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
     }

    const handleOnChangeNewResourceSubtype= (val,key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["resourceSubtype"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeNewUnit= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["unit"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeNewResource= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["resource"] = val.value;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    const setNewPrice= (val, key) => {
        let temp = newPriceList != undefined ? newPriceList : [];
        temp[key]["price"] = val;
        setNewPriceList(JSON.parse(JSON.stringify(temp)));
    }

    // edit deal
    const addEditPriceList = () => {
        let temp = editDeal;
        temp["priceList"].push({ resource: "", resourceType: "", resourceSubtype: "", unit:"", price:"" });
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const deleteEditPriceList = (key) => {
        let temp = editDeal;
        temp["priceList"].splice(key, 1);
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeEditResourceType= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["resourceType"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
     }

    const handleOnChangeEditResourceSubtype= (val,key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["resourceSubtype"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeEditUnit= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["unit"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const handleOnChangeEditResource= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["resource"] = val.value;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }

    const setEditPrice= (val, key) => {
        let temp = editDeal != undefined ? editDeal : [];
        temp["priceList"][key]["price"] = val;
        setEditDeal(JSON.parse(JSON.stringify(temp)));
    }
    
    const handleCreateNewDeal = () => {
        if (newDealName == "") { notifyWarning(t("deals.toast_empty_name")); return undefined; }
        if (newPriceList == undefined || newPriceList.length == 0) { notifyWarning(t("deals.toast_no_prices")); return undefined; }
        
        let unassignedValue = "";
        newPriceList.forEach(x => {
            if(x["resourceType"] == undefined || x["resourceType"] == ""){
                unassignedValue = "type";
                return;
            }
            if(x["unit"] == undefined || x["unit"] == ""){
                unassignedValue = "unit";
                return;
            }
            if(x["price"] == undefined || (isNaN(x["price"]) && x["price"] != "")){
                unassignedValue = "price";
                return;
            }
        });
        
        if(unassignedValue != ""){
            notifyWarning(t("deals.toast_unassigned_" + unassignedValue));
            return undefined;
        }
        
        axios.post('/api/deals/', {
            name: newDealName,
            description: newDealDescription,
            isDefaultDeal: newDefaultDeal,
            priceList: newPriceList,
        }
        ,{
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            if(nonDefaultDeal != undefined && nonDefaultDeal["_id"] != undefined) {
                axios.put('/api/deals/resetDefaultDeal/' + nonDefaultDeal["_id"], {
                    //isDefaultDeal: false,
                }, {
                    headers: {'x-access-token': auth.user["token"]}
                })
            }
            setUpdateTable(updateTable + 1);
            notifySuccess(t("deals.toast_created"));
            setShowNewModal(false);
            fetchData();
            resetForm();
        });
    };

    const handleEditDeal = () => {
        if (editDeal["name"] == "") { notifyWarning(t("deals.toast_empty_name")); return undefined; }
        if (editDeal["priceList"] == undefined || editDeal["priceList"].length == 0) { notifyWarning(t("deals.toast_no_prices")); return undefined; }
        
        let unassignedValue = "";
        editDeal["priceList"].forEach(x => {
            if(x["resourceType"] == undefined || x["resourceType"] == ""){
                unassignedValue = "type";
                return;
            }
            if(x["unit"] == undefined || x["unit"] == ""){
                unassignedValue = "unit";
                return;
            }
            if(x["price"] == undefined || (isNaN(x["price"]) && x["price"] != "")){
                unassignedValue = "price";
                return;
            }
        });
        
        if(unassignedValue != ""){
            notifyWarning(t("deals.toast_unassigned_" + unassignedValue));
            return undefined;
        }
        
        
        axios.put('/api/deals/' + editDeal["_id"], {
            name: editDeal["name"],
            description: editDeal["description"],
            isDefaultDeal: editDeal["isDefaultDeal"],
            priceList: editDeal["priceList"],
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            if(nonDefaultDeal != undefined && nonDefaultDeal["_id"] != undefined) {
                axios.put('/api/deals/resetDefaultDeal/' + nonDefaultDeal["_id"], {
                    //isDefaultDeal: false,
                }, {
                    headers: {'x-access-token': auth.user["token"]}
                }).then(function (response) {
                    setUpdateTable(updateTable + 1);
                    setShowEditModal(false);
                    notifySuccess(t("deals.toast_updated"));
                    fetchData();
                });
            } else {
                setUpdateTable(updateTable + 1);
                setShowEditModal(false);
                notifySuccess(t("deals.toast_updated"));
                fetchData();
            }
        });
    };

    const handleDeleteDeal = () => {
        axios.delete('/api/deals/' + deleteDeal["_id"], {
            id: deleteDeal["_id"]
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            fetchData();
            setShowDeleteModal(false);
            notifySuccess(t("deals.toast_deleted"));
            setUpdateTable(updateTable + 1);
        });
    };

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/resourcetypes",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/deals",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setAllResourceTypes(res[0]["data"]);
            setAllResources(res[1]["data"]);
            setAllDeals(res[2]["data"]);

        }))
        .catch(err => console.log(err));
    }
    
    function fetchResourceTypes(){
        axios.all([
            axios.single({
                method: "get",
                url: "/api/resourcetypes",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setAllResourceTypes(res[0]["data"]);
        }))
        .catch(err => console.log(err));
    }
    
    const handleChangeDefaultDeal = () => {
        let foundDefaultDeal:any = allDeals.find(deal => deal["isDefaultDeal"] != undefined ? deal["isDefaultDeal"] != false : null);
    
        if( Object.keys(editDeal).length !== 0 && editDeal["isDefaultDeal"] != true ) {
            setEditDefaultDeal(true);
        } else if(newDefaultDeal != true){
            setNewDefaultDeal(true);
        }

        if(foundDefaultDeal != undefined) setNonDefaultDeal(foundDefaultDeal);
        setShowChangeDefaultModal(false);
        setIsDefaultDeal(true);
    }

    const handleIsDefaultDealExit = (evt) => {
        let foundDefaultDeal:any = allDeals.find(deal => deal["isDefaultDeal"] != undefined ? deal["isDefaultDeal"] != false : null);
     
        if(foundDefaultDeal != undefined) { //reset default deal to non default deal.
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            setShowChangeDefaultModal(true);
        } else handleChangeDefaultDeal();
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchResourceTypes();
    }, [props.updateTable]);
    
    return(
    <div>
        <Card>
            <Accordion.Toggle className="clickable" as={Card.Header} eventKey="1">
                <h4 className="header-title">{t("settings.deals.title")}</h4>
                <p>{t("settings.deals.description")}</p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
                <Card.Body>
                    <Button className="newDealBtn" onClick={(handleShowNewModal)}>{t("deals.new")}</Button>
                    <PageTable
                        dataUrl={"/api/deals/getAllPaged"}
                        options={{
                            pageSize: 10,
                            showFields: [
                                //{ label: t("deals.name"), field: "name" },
                                { label: t("deals.name"), field: "name", override: dataLine => dataLine["isDefaultDeal"] == true ? <span><i className="dripicons-star" /> {dataLine["name"]}</span> :  dataLine["name"]}, 
                                { label: t("deals.description"), field: "description" },
                                { label: t("deals.totalprices"), field: "priceList", override: (dataline) => dataline["priceList"]!= undefined ? dataline["priceList"].length : ""},
                            ]
                        }}
                        exclusiveFilters={null}
                        loadingText={t("deals.loading")}
                        updateTable={updateTable}
                        dataAfter={(dataLine) => <Button onClick ={(evt) => handleShowDeleteModal(dataLine, evt)}> {t("deals.delete")} </Button>}
                        onLineClick={dataLine => dataLine["accessRule"] != "adminprivate" ? handleOpenDeal(dataLine) : null }
                        hover={true}
                        hoverExempt={dataLine => dataLine["accessRule"] == "adminprivate"}
                        hidePagination={false}
                        hideFilter={false}
                        defaultSortField="name"
                        defaultSortDirection="desc"
                    ></PageTable>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
        <Modal show={showNewModal} size="xl" onHide={handleCloseNewModal}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("deals.title_new")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Field
                    type="input"
                    title={t("deals.name")}
                    value={newDealName}
                    onChange={value => setNewDealName(value)}
                ></Field>
                <Field
                    type="input"
                    title={t("deals.description")}
                    value={newDealDescription}
                    onChange={value => setNewDealDescription(value)}
                ></Field>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>{t("deals.isdeault")}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Button disabled={isDefaultDeal} onClick={(evt) => handleIsDefaultDealExit(evt)} >
                        {t("deals.btn_default")}
                    </Button>
                </InputGroup>
                <p>{t("deals.descriptions.1")}</p>
                <p>{t("deals.descriptions.2_1")}<br/>{t("deals.descriptions.2_2")}</p>
                <p>{t("deals.descriptions.3_1")}<br/>{t("deals.descriptions.3_2")}</p>
                <hr/>
                <h3>{t("deals.pricelist")}</h3>
                <div>
                    <table className="pricelisttable">
                        <thead>
                            <tr>
                                <th>{t("deals.resource_type")}</th>
                                <th>{t("deals.resource_subtype")}</th>
                                <th>{t("deals.unit")}</th>
                                <th>{t("deals.resource")}</th>
                                <th>{t("deals.price")}</th>
                                <th>{t("deals.delete")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {newPriceList != undefined ? newPriceList.map((item, key) => 
                                <tr key={key}>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.resource_type")}
                                            value={{value: item["resourceType"], label: item["resourceType"]}}
                                            onChange={(val) => {
                                                handleOnChangeNewResourceType(val, key)
                                            }}
                                            options={{
                                                choosetext: t("deals.resource_type_choosetext"),
                                                choices: allResourceTypes!= undefined ? allResourceTypes.map(i => { return { label: i["name"], value: i["_id"] } }) : null

                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.resource_subtype")}
                                            value={item["resourceSubtype"]}
                                            onChange={(val) => {
                                                handleOnChangeNewResourceSubtype(val, key)
                                            }}
                                            options={{
                                                choosetext: t("deals.resource_subtype_choosetext"),
                                                choices: allResourceTypes!= undefined ? ((allResourceTypes.find(i => i["_id"] == item["resourceType"]) || {})["resourceSubtype"] || []).map(i => { return { label: i, value: i } }) : [] 
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.unit")}
                                            value={{value: item["unit"], label: item["unit"]}}
                                            onChange={(val) => {
                                                handleOnChangeNewUnit(val, key)
                                            }}
                                            options={{
                                            choosetext: t("deals.type_choosetext"),
                                                choices: [
                                                    { label: t("general.unit.unittypesingle.day"), value: "day" },
                                                    { label: t("general.unit.unittypesingle.week"), value: "week" },
                                                    { label: t("general.unit.unittypesingle.month"), value: "month" },
                                                    { label: t("general.unit.unittypesingle.hour"), value: "hour" },
                                                    { label: t("general.unit.unittypesingle.once"), value: "once" }
                                                ]
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.resrouce")}
                                            value={{value: item["resource"], label: item["resource"]}}
                                            onChange={(val) => {
                                                handleOnChangeNewResource(val, key)
                                            }}
                                            options={{
                                                choosetext: t("deals.resource_choosetext"),
                                                choices: allResources!= undefined ? (allResources.filter(i => i["resourceSubtype"] == newPriceList[key]["resourceSubtype"] )).map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="input"
                                            //title={t("deals.price")}
                                            value={item["price"]}
                                            onChange={(val) => {
                                                setNewPrice(val, key)
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <InputGroup.Append>
                                            <Button onClick={(evt) => deletePriceList(key)}>{t("deals.pricelist_delete")}</Button>
                                        </InputGroup.Append>
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                    <Button onClick={addPriceList}>{t("deals.pricelist_add")}</Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCloseNewModal}>
                    {t("deals.cancel")}
                </Button>
                <Button onClick={handleCreateNewDeal}>
                    {t("deals.save")}
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal size="xl" show={showEditModal} onHide={() => setShowEditModal(false)} >
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("deals.edit")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Field
                    type="input"
                    title={t("deals.name")}
                    value={editDeal["name"]}
                    onChange={value => setEditDealName(value)}
                ></Field>
                <Field
                    type="input"
                    title={t("deals.description")}
                    value={editDeal["description"]}
                    onChange={value => setEditDealDescription(value)}
                ></Field>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>{editDeal["isDefaultDeal"] ? t("deals.isdeault") : ""}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Button disabled={editDeal["isDefaultDeal"] != true ? false : true} onClick={(evt) => handleIsDefaultDealExit(evt)}>
                        {t("deals.btn_default")}
                    </Button>
                </InputGroup> 
                <hr/>
                <div>
                    <table className="pricelisttable">
                        <thead>
                            <tr>
                                <th>{t("deals.resource_type")}</th>
                                <th>{t("deals.resource_subtype")}</th>
                                <th>{t("deals.unit")}</th>
                                <th>{t("deals.resource")}</th>
                                <th>{t("deals.price")}</th>
                                <th>{t("deals.delete")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {editDeal["priceList"] != undefined ? editDeal["priceList"].map((i, key) => 
                                <tr key={key}>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.resource_type")}
                                            value={{value: i["resourceType"], label: i["resourceType"]}}
                                            onChange={(val) => {
                                                handleOnChangeEditResourceType(val, key)
                                            }}
                                            options={{
                                                choosetext: t("deals.resource_type_choosetext"),
                                                choices: allResourceTypes!= undefined ? allResourceTypes.map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.resource_subtype")}
                                            value={{value: i["resourceSubtype"], label: i["resourceSubtypes"]}}
                                            onChange={(val) => {
                                                handleOnChangeEditResourceSubtype(val, key)
                                            }}
                                            options={{
                                                choosetext: t("deals.resource_subtype_choosetext"),
                                                choices: allResourceTypes!= undefined ? ((allResourceTypes.find(i => i["_id"] == editDeal["priceList"][key]["resourceType"]) || {})["resourceSubtype"] || []).map(i => { return { label: i, value: i } }) : [] 
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.unit")}
                                            value={{value: i["unit"], label: i["unit"]}}
                                            onChange={(val) => {
                                                handleOnChangeEditUnit(val, key)
                                            }}
                                            options={{
                                            choosetext: t("deals.unit_choosetext"),
                                                choices: [
                                                    { label: t("general.unit.unittypesingle.day"), value: "day" },
                                                    { label: t("general.unit.unittypesingle.week"), value: "week" },
                                                    { label: t("general.unit.unittypesingle.month"), value: "month" },
                                                    { label: t("general.unit.unittypesingle.hour"), value: "hour" },
                                                    { label: t("general.unit.unittypesingle.once"), value: "once" }
                                                ]
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="select"
                                            //title={t("deals.resrouce")}
                                            value={{value: i["resource"], label: i["resource"]}}
                                            onChange={(val) => {
                                                handleOnChangeEditResource(val, key)
                                            }}
                                            options={{
                                                choosetext: t("deals.resource_choosetext"),
                                                choices: allResources!= undefined ? (allResources.filter(i => i["resourceSubtype"] == editDeal["priceList"][key]["resourceSubtype"])).map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <Field
                                            type="input"
                                            //title={t("deals.price")}
                                            value={i["price"]}
                                            onChange={(val) => {
                                                setEditPrice(val, key)
                                            }}
                                        ></Field>
                                    </td>
                                    <td>
                                        <InputGroup.Append>
                                            <Button onClick={(evt) => deleteEditPriceList(key)}>{t("deals.pricelist_delete")}</Button>
                                        </InputGroup.Append>
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                    <Button onClick={addEditPriceList}>{t("deals.pricelist_add")}</Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setShowEditModal(false)}>
                    {t("deals.cancel")}
                </Button>
                <Button onClick={handleEditDeal}>
                    {t("deals.save")}
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("deals.delete")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t("deals.delete_info")}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setShowDeleteModal(false)}>
                    {t("deals.cancel")}
                </Button>
                <Button onClick={handleDeleteDeal}>
                    {t("deals.delete")}
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal show={showChangeDefaultModal} onHide={() => setShowChangeDefaultModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("deals.change_default")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t("deals.change_default_info")}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setShowChangeDefaultModal(false)}>
                    {t("deals.cancel")}
                </Button>
                <Button onClick={() => handleChangeDefaultDeal()}>
                    {t("deals.confirm")}
                </Button>
            </Modal.Footer>
        </Modal>
    </div>
       
    );
}
 
export default SettingsDeal;